/* eslint-disable */
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { message } from 'antd'
import WrappedDrawer from '@/components/WrappedDrawer'
import { createSystemPermission, updateSystemPermission } from '@/service/systemControl'
import {
  getPermissionParentCodePrefix
} from '@/utils/rolePermissionTree'
import PermissionForm from './PermissionForm'

class PermissionEditDrawer extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    actType: PropTypes.oneOf(['create', 'edit']),
    record: PropTypes.object,
    /** 新建子权限时预填父级 id */
    defaultParentId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    baseProps: PropTypes.object,
    onSuccess: PropTypes.func,
    title: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    permissionsList: PropTypes.array
  }

  static defaultProps = {
    actType: 'create',
    baseProps: {}
  }

  buildPayload = (fields) => {
    const { permissionsList } = this.props
    const parentRaw = fields.parentId
    let parentId = null
    if (parentRaw != null && parentRaw !== '') {
      const n = Number(parentRaw)
      parentId = Number.isNaN(n) ? parentRaw : n
    }
    const name = String(fields.name || '').trim()
    const codePrefix = getPermissionParentCodePrefix(permissionsList, parentRaw)
    const codeSuffix = String(fields.code || '').trim()
    const code = codePrefix ? `${codePrefix}${codeSuffix}` : codeSuffix
    return {
      parentId,
      type: String(fields.value || '').trim(),
      name,
      code,
      remark: String(fields.remark || '').trim()
    }
  }

  handleOk = async (form) => {
    const { onSuccess, actType, record } = this.props
    const fields = await form.current.validateFields()
    const payload = this.buildPayload(fields)
    try {
      if (actType === 'edit') {
        const id = record?.id
        if (id == null) {
          message.error('缺少权限 id')
          throw new Error('缺少权限 id')
        }
        await updateSystemPermission(id, payload)
        message.success('保存成功')
      } else {
        await createSystemPermission(payload)
        message.success('创建成功')
      }
      if (typeof onSuccess === 'function') {
        await Promise.resolve(onSuccess())
      }
    } catch (e) {
      message.error(e?.message || e?.msg || (actType === 'edit' ? '保存失败' : '创建失败'))
      throw e
    }
  }

  render() {
    const { children, baseProps, title, width, actType, record, defaultParentId } = this.props
    const drawerTitle =
      title !== undefined && title !== null
        ? title
        : actType === 'edit'
          ? '编辑权限'
          : defaultParentId != null && defaultParentId !== ''
            ? '新增子权限'
            : '新建权限'
    const mergedBaseProps =
      actType === 'edit'
        ? { ...baseProps, actType, initialRecord: record }
        : { ...baseProps, actType, defaultParentId }

    return (
      <WrappedDrawer
        children={children}
        title={drawerTitle}
        width={width !== undefined ? width : 560}
        baseComponent={<PermissionForm />}
        baseProps={mergedBaseProps}
        onOk={this.handleOk}
        bodyStyle={{
          padding: '12px 16px 72px'
        }}
      />
    )
  }
}

const mapStateToProps = (state) => ({
  permissionsList: state.use.systemPermission.list
})

export default connect(mapStateToProps)(PermissionEditDrawer)
